import { Div } from '@dnb/eufemia';
import classNames from 'classnames';

import { ApiDetailedResponse } from '@/openapi/schema';
import { capitalizeFirstLetterOfString } from '@/utils/textUtils';

import style from './index.module.css';

export type ApiStage = ApiDetailedResponse['stage'] | Lowercase<ApiDetailedResponse['stage']>;

interface Props {
  stage: ApiStage;
  compact?: boolean;
}

export default function ApiStageBadge({ stage, compact = false }: Props) {
  const badgeValue = capitalizeFirstLetterOfString(stage.toLowerCase());

  return (
    <Div className={classNames(style['badge'], compact && style['compact'], style[stage.toLowerCase()])}>
      {badgeValue}
    </Div>
  );
}
